export const apps2 = [
  {
    name: 'Index',
    url: '/apps/',
    icon: 'icon-home'
  }
];
